import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const PRIMARY_PHONE_TYPE_MAP = {
    home: 'homeNumber',
    mobile: 'cellNumber',
    work: 'workNumber'
};

const fn = ($scope, $state, $stateParams, $q, ServiceRequestService, InsuranceSuiteMetadata, $window, httpSettings, $filter, LocaleService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;
        $scope.claimCenterDownloadURI = `${httpSettings.serviceBaseURLs.cc}document`;
        $scope.serviceRequestNumber = $stateParams.serviceRequestNumber;
        $scope.tabs = [{
            name: 'messages',
            active: true
        }, {
            name: 'invoices',
            active: false
        }, {
            name: 'history',
            active: false
        }, {
            name: 'documents',
            active: false
        }];
        if ($stateParams.tab) {
            const tab = _.find($scope.tabs, {
                name: $stateParams.tab
            });
            if (tab) {
                tab.active = true;
            }
        }
        // $scope.documentsToDownload = [];
        $scope.tab = $stateParams.tab || 'messages';
        $scope.serviceRequest = {};
        $scope.quoteExists = false;
        $scope.showFullInstructions = true;
        $scope.isOverdue = false;
        $scope.truncatedInstructions = '';
        $scope.firstOperation = '';
        $scope.otherOperations = [];
        $scope.sortedHistory = [];
        $scope.invoiceStatuses = InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestInvoiceStatus');
        $scope.quoteStatuses = InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestQuoteStatus');
        $scope.actions = InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestOperation');

        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber();

        $scope.serviceRequestPromise = ServiceRequestService.getServiceRequestDetails($scope.serviceRequestNumber).then(
            (serviceRequest) => {
                $scope.serviceRequest = serviceRequest;
                $scope.isOverdue = $scope.serviceRequest.isOverdue;
                $scope.quoteExists = angular.isDefined($scope.serviceRequest.latestQuote);
                const hasDefaultOperation = angular.isDefined($scope.serviceRequest.defaultOperation);
                $scope.firstOperation = hasDefaultOperation ? $scope.serviceRequest.defaultOperation : _.head($scope.serviceRequest.otherOperations);
                if ($scope.firstOperation === undefined || $scope.firstOperation === '') {
                    $scope.firstOperation = $scope.serviceRequest.canCancel ? ('specialistcanceled') : $scope.firstOperation;
                }
                $scope.otherOperations = hasDefaultOperation ? $scope.serviceRequest.otherOperations : _.tail($scope.serviceRequest.otherOperations);
                $scope.dueDate = serviceRequest.serviceDateApplies ? serviceRequest.expectedServiceCompletionDate : serviceRequest.expectedQuoteCompletionDate;

                const customerContactPreferredNumberType = _.get(PRIMARY_PHONE_TYPE_MAP, serviceRequest.customerContact.primaryPhoneType);
                const claimHandlerPreferredNumberType = _.get(PRIMARY_PHONE_TYPE_MAP, serviceRequest.claimHandler.primaryPhoneType);
                $scope.customerContactPreferredNumber = _.get(serviceRequest.customerContact, customerContactPreferredNumberType);
                $scope.claimHandlerPreferredNumber = _.get(serviceRequest.claimHandler, claimHandlerPreferredNumberType);

                $scope.invoiceTotal = {
                    amount: serviceRequest.outstandingInvoiceAmount.amount + serviceRequest.paymentsMadeAmount.amount,
                    currency: serviceRequest.outstandingInvoiceAmount.currency
                };
                $scope.sortedHistory = $scope.serviceRequest.history.sort((a, b) => {
                    return b.sequence - a.sequence;
                });
                if (serviceRequest.additionalInstructions && serviceRequest.additionalInstructions.length > 100) {
                    $scope.showFullInstructions = false;
                    $scope.truncatedInstructions = `${serviceRequest.additionalInstructions.substr(0, 100)}...`;
                }
                if (serviceRequest.canDelay) {
                    $scope.otherOperations.push('vendordelayed'); // Not a real SR Operation - but needed to reflect ability to delay date in CC
                }
                if ($scope.serviceRequest.existingDocumentsToLink === undefined) {
                    $scope.serviceRequest.existingDocumentsToLink = [];
                }
                if (serviceRequest.otherOperations.length > 0) {
                    $scope.otherOperations.push('closeService');
                }
            },
            (error) => {
                console.error('service request retrieval failed', error);
            }
        );
    };

    ctrl.lookupInvoiceStatus = (status) => {
        return $scope.invoiceStatuses.getCode(status);
    };

    ctrl.lookupQuoteStatus = (status) => {
        return $scope.quoteStatuses.getCode(status);
    };

    ctrl.lookupActionNameMessageKey = (action, serviceRequest) => {
        if (action) {
            if (action === 'addquote') {
                if (serviceRequest.isReviseQuote || $scope.quoteExists) {
                    return 'servicerequest.services.ServiceRequestService.action.Revise Quote';
                }
                return 'servicerequest.services.ServiceRequestService.action.Add Quote';
            } else if (action === 'vendordelayed') { // not an operation in CC, but an available action
                return 'servicerequest.services.ServiceRequestService.action.Report a Delay';
            }else if (action === 'closeService') {
                return 'servicerequest.services.ServiceRequestService.action.Close Service';
            }
            const actionCode = $scope.actions.getCode(action);
            return ServiceRequestService.getOperationNameMessageKey(actionCode);
        }
    };

    ctrl.goToQuoteDetails = () => {
        const state = $state.get('quoteDetails');
        state.data.serviceRequest = $scope.serviceRequest;
        $state.transitionTo(state);
    };

    ctrl.addOrReviseQuote = () => {
        const state = $state.get('addOrReviseQuote');
        state.data.serviceRequest = $scope.serviceRequest;
        $state.transitionTo(state);
    };

    ctrl.addInvoice = () => {
        const state = $state.get('addInvoice');
        state.data.serviceRequest = $scope.serviceRequest;
        $state.transitionTo(state);
    };

    
    // ctrl.closeService = () => {
    //     $scope.closeServicePromise = ServiceRequestService.closeServiceRequest_EY($scope.serviceRequest.serviceRequestNumber).then(
    //         () => {
    //             $scope.serviceRequestPromise()
    //             //$state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
    //         },
    //         () => {
    //             ModalService.showError(
    //                 'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Close Service failed',
    //                 'servicerequest.controllers.ServiceRequestWorkOperationCtrl.Please contact the system administrator.'
    //             );
    //         }
    //     );
    // };


    ctrl.addMessage = () => {
        const state = $state.get('createMessage');
        $state.transitionTo(state, {
            serviceRequestNumber: $scope.serviceRequest.serviceRequestNumber
        });
    };

    ctrl.goToInvoiceDetails = (invoice) => {
        const state = $state.get('invoiceDetails');
        state.data.serviceRequest = $scope.serviceRequest;
        state.data.invoice = invoice;
        $state.transitionTo(state);
    };

    ctrl.withdrawInvoice = (invoice) => {
        const state = $state.get('withdrawInvoice');
        state.data.serviceRequestNumber = $scope.serviceRequest.serviceRequestNumber;
        state.data.invoice = invoice;
        $state.transitionTo(state);
    };

    ctrl.getPaidInvoicesTotal = (serviceRequest) => {
        return _.reduce(serviceRequest.invoices, (total, invoice) => {
            return total + (angular.isDefined(invoice.paymentDate) ? invoice.totalAmount : 0);
        }, 0);
    };

    ctrl.getUnpaidInvoicesTotal = (serviceRequest) => {
        return _.reduce(serviceRequest.invoices, (total, invoice) => {
            return total + (!angular.isDefined(invoice.paymentDate) ? invoice.totalAmount : 0);
        }, 0);
    };

    ctrl.performOperation = (operationListItem) => {
        let stateName = '';
        switch (operationListItem) {
            case 'specialistacceptedwork':
                stateName = 'acceptWork';
                break;
            case 'specialistdeclined':
                stateName = 'declineWork';
                break;
            case 'specialistcompletedwork':
                stateName = 'completeWork';
                break;
            case 'specialistcanceled':
                stateName = 'cancelWork';
                break;
            case 'addinvoice':
                $scope.addInvoice();
                break;
            case 'addquote':
                $scope.addOrReviseQuote();
                break;
            case 'specialistwaiting':
                stateName = 'reportBlocked';
                break;
            case 'specialistresumedwork':
                stateName = 'resumeWork';
                break;
            case 'vendordelayed':
                stateName = 'reportDelay';
                break;
            // case 'closeService':
            //     $scope.closeService();
            //     break;
            case 'closeService':
                stateName = 'closeService';
                break;
            default:
                break;
        }

        if (stateName !== '') {
            const state = $state.get(stateName);
            state.data.serviceRequest = $scope.serviceRequest;
            state.data.action = operationListItem;
            $state.transitionTo(state);
        }
    };

    ctrl.selectTab = (tabNum) => {
        for (let i = 0; i < $scope.tabs.length; i++) {
            $scope.tabs[i].active = i === tabNum;
        }
    };

    ctrl.getNextStep = () => {
        return $scope.serviceRequest.nextStepOwnerIsSpecialist ? $scope.serviceRequest.nextStep :
            $filter('translate')('servicerequest.views.service-request-details.Wait for:') + $scope.serviceRequest.nextStep;
    };

    ctrl.formatPhoneNumber = (contact) => {
        /* if (phone) {
            let tempPhoneMask = $scope.phoneMask;
            for (let i = 0; i < phone.length; i++) {
                console.log(phone[i]);
                var k = phone[i];
                tempPhoneMask.replace(/[0-8]/g, phone[i]);
            }
            return tempPhoneMask;
        }
        return '';*/
        if (contact === undefined) {
            return '';
        }
        let phoneNumber;
        if (contact.primaryPhoneType === 'home') {
            phoneNumber = contact.homeNumber;
        } else if (contact.primaryPhoneType === 'work') {
            phoneNumber = contact.workNumber;
        } else {
            phoneNumber = contact.cellNumber;
        }

        if (phoneNumber) {
            let phone = phoneNumber.toString();
            //no formatting
            if (phone[0] === '+') {
                return phone;
            }
            let arr = $scope.phoneMask.split('');
            let maskIndex = 0;
            for (let i = 0; i < phone.length; i++) {
                for (; maskIndex < arr.length; maskIndex++) {
                    if (/^[0-9]$/.test(arr[maskIndex])) {
                        arr[maskIndex] = phone[i];
                        maskIndex++;
                        break;
                    }
                }
            }
            return arr.join('');
        }
        return '';
    };


    ctrl.formatAddress = (address) => {
        let addressStr = '';
        if (address) {
            if (address.addressLine1) {
                addressStr = addressStr + address.addressLine1 + ', ';
            }
            if (address.city) {
                addressStr = addressStr + address.city + ', ';
            }
            addressStr = addressStr + address.state;
            if (address.postalCode) {
                addressStr = addressStr + ', ' + address.postalCode;
            }
        }
        return addressStr;
    };

    /* ctrl.downloadAllDocuments = () => {
        console.log($scope.documentsToDownload);
    }; */
    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$stateParams', '$q', 'servicerequest.ServiceRequestService', 'InsuranceSuiteMetadata', '$window', 'httpSettings', '$filter', 'LocaleService'];

export default fn;
